import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_SUB002_Request,
  IAPI_SUB002_Response,
  IAPI_SUB003_Request,
  IAPI_SUB003_Response,
} from "../../../type/apiType";

/**
 * 補助金交付申請参照API
 */
const httpAPI_SUB002 = async (
  param: IAPI_SUB002_Request
): Promise<IAPI_SUB002_Response> => {
  let res = await http.post(ApiUrl.API_SUB002, {
    ...param,
  });

  return res.data;
};

/**
 * 補助金交付申請更新API
 */
const httpAPI_SUB003 = async (
  param: IAPI_SUB003_Request
): Promise<IAPI_SUB003_Response> => {
  let res = await http.post(ApiUrl.API_SUB003, {
    ...param,
  });

  return res.data;
};

/**
 * 申請状況更新API
 */
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_SUB002, httpAPI_SUB003, httpAPI_APP016 };
